<template>
  <div id="access-control">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          :externalLoading="loading"
          ref="CRUDTable"
          :remoteCreateItem="remoteCreateItem"
          :remoteUpdateItem="remoteUpdateItem"
          :remoteDeleteItem="remoteDeleteItem"
          :remoteGetItem="remoteGetItem"
          :fetchList="fetchList"
          editWith="1000px"
          :searchKeyWord="searchKeyWord"
          :formConfig="formConfig"
          :inputConfigs="inputConfigs"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
          :showExpand="true"
          :expanded.sync="expanded"
          :singleExpand="singleExpand"
          @update:expanded="handleExpanded"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row>
                <v-col>
                  <div class="mt-5">
                    <v-btn
                      @click="saveRoleMenu(item.id)"
                      depressed
                      class="mr-5"
                      color="primary"
                    >
                      Save
                    </v-btn>
                    <v-btn
                      @click="resetRoleMenu(item.id)"
                      depressed
                      class="mr-5"
                      color="secondary"
                    >
                      Reset
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" v-for="tempList in Thelists">
                  <v-checkbox
                  :label= "tempList.name"
                  :v-model= "tempList.value"
                    input-value="true"
                    value
                ></v-checkbox>
                </v-col>
  
                  <!--
                    :active="(e)=>selection[endpointMenuItem.sectionTitle].push(e)"
                    @input="selectedItems => handleTreeview(selectedItems, item.id)"
                    @update:active="(e)=>handleActive(e,endpointMenuItem.sectionTitle)" -->
              
              </v-row>
            </td>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
 import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/user'
import { fetchList as fetchListByEndpoint } from '@/api/sysRole'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref, reactive, nextTick } from 'vue'
import moment from '@/utils/moment'

export default {
  components: {
    CRUDTable,
    // uInput,
    // UserListAddNew,
  },
  methods: {
    saveRoleMenu(roleID){
      console.log('roleID',roleID)
      let sysRoleMenus = []
      for (let index = 0; index < 10; index++) {
        if(this.selection[index] && this.selection[index].length > 0){
          this.selection[index].forEach(menuItem => {
            sysRoleMenus.push({
              SysMenuID: menuItem.id
            })
          })
        }
      }
      let postData = {
        id: roleID,
        SysRoleMenus: sysRoleMenus
      }
      console.log('postData',postData)
      updateRoleMenu(postData).then((response) =>{
        console.log('updateRoleMenu response', response)
      })
    },
    resetRoleMenu(roleId){
      console.log('roleID',roleID)
    },
    handleExpanded(expandedRows) {
      console.log('expandedRows', expandedRows)
      let returnNode = {}
      let getEndNode = (node, id)=>{
        // console.log('expandedRows node' , node)
        // console.log('expandedRows node id ' , id)
        // console.log('expandedRows node' , node)
        if(returnNode.id){
          return
        }
        // console.log('getEndNode',node.id)
        if(node.id === id){
          returnNode = Object.assign({},node)
          // console.log('returnNode',returnNode)
          return
        }
        if(node.children && node.children.length > 0) {
          node.children.forEach(child=>{
            if(returnNode.id){
              return
            }
            // console.log('child returnNode',returnNode)
            getEndNode(child, id)
          })
        }

      }
      

      let sysMenuItem = expandedRows[0].sysUserRoles.forEach(sysRoleMenu => {
        this.endpointMenuItems.forEach((endpointMenu, index) => {
          returnNode = {}
          if(endpointMenu.children && endpointMenu.children.length > 0) {
            getEndNode(endpointMenu,sysRoleMenu.sysMenuID)
            this.selection[0].push(returnNode)
          }
        });
      })

      // this.$set(this.selection, );
    },
    getSelectionName(id, sectionTitle) {
      return id + '_' + sectionTitle
    },
    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },
    handleActive(e, index){
      console.log('e, index', e,index)
      let clickNode = e[0]
      let checkExist = false
      if(!clickNode){
        return
      }
      this.selection[index].push(clickNode)

      console.log('this.selection[index]', this.selection[index])
      this.activeArr[index] = []
    }
  },
  setup() {
    const active = ref([])
    const store = useStore()
    console.log('store', store)
    const roleMenus = reactive({
      roleID: -1,
      sysMenus: [],
    })

    const handleTreeview = ref((selectedItems, id, selection) => {
      console.log('selectedItems, id, selection', selectedItems, id,selection)
      roleMenus.value = {
        roleID: id,
        sysMenus: selectedItems,
      }
      console.log('roleMenus', roleMenus)
    })
    let selection = reactive({
      0:[],
      1:[],
      2:[],
      3:[],
      4:[],
      5:[],
      6:[],
      7:[],
      8:[],
      9:[]
    })
    let activeArr = reactive({
      0:[],
      1:[],
      2:[],
      3:[],
      4:[],
      5:[],
      6:[],
      7:[],
      8:[],
      9:[]
    })
    const endpointMenuItems = ref([])
    fetchListByEndpoint({page: 0, limit: 0}).then(response => {
      // console.log('sysmenu', response)
      endpointMenuItems.value = response.data.record
      console.log('sys Role Menu', endpointMenuItems.value)
    })

    const singleExpand = ref(true)
    const expanded = []
    const CRUDTable = ref(null)
    const loading = ref(false)
    const searchKeyWord = ref('')
    const organizations = ref([])
    let formConfig = {
        title: 'User Management',
        headers: [
          { value: 'id', text: 'Id' },
          { value: 'userNo', text: 'UserNo'},
          { value: 'hkid', text: 'HKID' },
          { value: 'nickName', text: 'NickName' },
          { value: 'firstName', text: 'FirstName' },
          { value: 'lastName', text: 'LastName' },
          { value: 'email', text: 'Email' },
          { value: 'mobileNo', text: 'MobileNo' },
          { value: 'birthday', text: 'Birthday' },
          { value: 'gender', text: 'Gender' },
          { value: 'actions', text: 'Actions', sortable: false },
        ],
        customColumns: [
          {
            name: 'birthday',
            callback(birthday) {
              // console.log('in domainUsers callback', domainUsers)
              if (birthday) {
               return moment(birthday).format('YYYY-MM-DD')
              }
              return null
            },
          },
        ],
		
		
		
		
		
		
 
		
    }
    return {
      activeArr,
      endpointMenuItems,
      handleTreeview,
      selection,
      singleExpand,
      expanded,
      CRUDTable,
      organizations,
      searchKeyWord,
      remoteCreateItem: createItem,
      remoteUpdateItem: updateItem,
      remoteDeleteItem: deleteItem,
      remoteGetItem: getItem,
      fetchList: fetchList,
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiExportVariant,
        mdiAccountOutline,
      },
      loading,
      inputConfigs: 	     [
        //   { md: 12,  propName: 'id', label: 'Id', readonly: true },
        //   {
        //     md: 6,
        //     propName: 'code',
        //     label: 'Code',
        //     type: {
        //       name: 'select',
        //       storeName: 'orgs',
        //       itemText: 'name',
        //     },
        //   },
          { md: 12, propName: 'userNo', label: 'UserNo' },
          { md: 12, propName: 'hkid', label: 'HKID' },
          { md: 12, propName: 'nickName', label: 'NickName' },
          { md: 12, propName: 'firstName', label: 'firstkName' },
          { md: 12, propName: 'lastName', label: 'LastName' },
          { md: 12, propName: 'email', label: 'Email' },
          { md: 12, propName: 'mobileNo', label: 'MobileNo' },
          {        
          md: 12,
          propName: 'birthday',
          label: 'Birthday',
          type: {
            name: 'datepicker',
          },
        },
        {  md: 12, propName: 'gender', label: 'Gender'  },
        ],
      formConfig: formConfig,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
